import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { FileUploadModel } from 'src/app/shared/models/fileModel';
// import { FileService } from '../../../core/services/file.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Subject } from 'rxjs';
import { ConfirmDialogModel, ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { TelemetryServices } from 'src/app/core/services/telemetry.service';
import { Router } from '@angular/router';
export interface AttachData {
  attachmentList: any;
}

@Component({
  selector: 'app-attachment-dialog',
  templateUrl: './attachment-dialog.component.html',
  styleUrls: ['./attachment-dialog.component.scss'],
  animations: [
    trigger('fadeInOut', [
      state('in', style({ opacity: 100 })),
      transition('* => void', [animate(3000, style({ opacity: 0 }))]),
    ]),
  ],
  standalone: false,
})
export class AttachmentDialogComponent implements OnInit, OnDestroy {
  multiple: boolean = true;
  multiSelectFlag: boolean = false;
  fileSizeError: any;
  // fileTotalSize:any;
  uploadResponse = { status: '', message: 0, filePath: '' };
  files: Array<FileUploadModel> = [];
  fileMerge = [];
  fileMultiMerge = [];
  filenameProgressbar: string;
  filename = [];
  fileArray = [];
  attachData: Array<AttachData> = [];
  allowedFileTypes: string = '';
  uploadType: string = 'multiple';
  fileDeleteSub = new Subject();
  key: number;
  lastindex: number;
  dialogResponse: any;
  editFileNameArray = [];
  editFileName = [];
  existingFiles = [];
  cmpHirType: any = localStorage.getItem('fresherCompHiringTypeId');
  isMapFile: boolean = false;
  ifAtchType: boolean = false;
  data1 = {
    // Required
    type: 'Attachment-Dialog', //Required. Impression type (list, detail, view, edit, workflow, search)
    subtype: '', //Optional. Additional subtype. "Paginate", "Scroll"
    pageid: '10', //Required.  Unique page id
    itype: '', // type of interaction - SWIPE, SCRUB (fast forward using page thumbnails) or AUTO
    stageto: '', // game level, stage of page id to which the navigation was done
  };

  constructor(
    private _telemetryServices: TelemetryServices,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<AttachmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
    private router: Router,
    //  private fileService: FileService,
  ) {
    this.allowedFileTypes = data.allowedfileType;
    this.uploadType = data.uploadType;
    this.editFileNameArray = data.editFileNameArray;
    this.existingFiles = data.existingFiles;
    this.isMapFile = data.isMapFile;
    if ((this.cmpHirType == '1' || this.cmpHirType == '4') && this.isMapFile) {
      this.ifAtchType = true;
    }

    if (this.editFileNameArray && this.editFileNameArray.length > 0) {
      this.editFileNameArray.forEach((file) => {
        let fileName = file.fileName;
        if (this.ifAtchType) {
          fileName = fileName.substring(fileName.indexOf('-') + 1, fileName.length);
        }
        this.editFileName.push(fileName);
      });
    }

    if (this.existingFiles && this.existingFiles.length > 0) {
      this.existingFiles.forEach((file) => {
        let fileName = file;
        if (this.ifAtchType) {
          fileName = fileName.substring(fileName.indexOf('-') + 1, fileName.length);
        }
        this.editFileName.push(fileName);
      });
    }
  }

  /**For File Select functionality**/
  onFileSelected(event) {
    const files = event.dataTransfer ? event.dataTransfer.files : event.target.files;
    this.fileUploading(files);
  }

  /**For Drag and Drop functionality**/
  uploadFile(event) {
    const files = event;
    this.fileUploading(files);
  }

  fileUploading(files) {
    this.key = 1;
    let errorFile = false;
    for (const file of files) {
      if (!this.validate(file)) {
        errorFile = true;
      }
    }

    if (!errorFile) {
      errorFile = false;
      this.fileSizeError = '';
      for (const file of files) {
        const message = 'Are you sure you want to overide ' + file.name + ' ?';
        const dialogData = new ConfirmDialogModel(message, '');

        if (this.filename.indexOf(file.name) === -1) {
          if (this.editFileName.indexOf(file.name) !== -1) {
            const dialogRef = this.dialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: dialogData });
            dialogRef.afterClosed().subscribe((dialogResult) => {
              if (dialogResult) {
                this.filename.push(file.name);
                this.insertFileValue(file);
              }
            });
          } else {
            this.fileMerge = [];
            this.fileArray.push(file);
            this.filename.push(file.name);
          }
        } else {
          const dialogRef = this.dialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: dialogData });
          dialogRef.afterClosed().subscribe((dialogResult) => {
            if (dialogResult) {
              // this.filename.push(file.name);
              this.insertFileValue(file);
            }
          });
        }
      }
    }
  }

  insertFileValue(file) {
    const fileArrValues = [];
    this.fileArray.forEach((fileArr) => {
      if (file.name != fileArr['name']) {
        fileArrValues.push(fileArr);
        // console.log(fileArr.file)
      }
    });
    //Override the last same name file
    delete this.fileArray;
    this.fileArray = fileArrValues;
    this.fileArray.push(file);
    //console.log('A',this.fileArray,this.filename);
  }

  validate(file: File) {
    const fileType = this.getFileExtension(file.name);
    if (
      file.size > 5242880 &&
      (fileType == 'xlsx' ||
        fileType == 'xls' ||
        fileType == 'png' ||
        fileType == 'jpg' ||
        fileType == 'jpeg' ||
        fileType == 'msg')
    ) {
      this.fileSizeError = 'Please upload a maximum 5MB size only';
      return false;
    } else if (file.size > 5242880 && (fileType == 'doc' || fileType == 'docx' || fileType == 'pdf')) {
      this.fileSizeError = 'Please upload maximum 5MB size only.';
      return false;
    } else if (
      this.router.url.includes('candidate-creation') &&
      (localStorage.getItem('roleCode') == 'DBAD' || localStorage.getItem('roleCode') == 'DBAS') &&
      fileType != 'doc' &&
      fileType != 'docx' &&
      fileType != 'pdf'
    ) {
      this.fileSizeError = 'Please upload the correct format doc|docx|pdf';
      return false;
    } else if (
      fileType != 'doc' &&
      fileType != 'docx' &&
      fileType != 'pdf' &&
      fileType != 'xlsx' &&
      fileType != 'xls' &&
      fileType != 'png' &&
      fileType != 'jpg' &&
      fileType != 'jpeg' &&
      fileType != 'msg'
    ) {
      this.fileSizeError = 'Please upload the correct format doc|docx|pdf|xls|xlsx|png|jpg|jpeg|msg.';
      return false;
    }
    return true;
  }

  ngOnInit() {
    //  console.log(this.data);
    // telemtry  API CALL and, send data
    this.data1.subtype = 'Attachment Icon ';
    this.data1.itype = 'AUTO';
    this.data1.stageto = 'intial attachment loading';
    if (this.data1) {
      this._telemetryServices.telemetryImpression(this.data1);
    }
  }

  closeDialog() {
    this.dialogRef.close();
    this.data1.subtype = 'icon click';
    this.data1.itype = 'particular icon click';
    this.data1.stageto = 'attaching a file';
    if (this.data1) {
      this._telemetryServices.telemetryInteract(this.data1);
    }
  }

  getFileExtension(filename) {
    return filename.split('.').pop();
  }

  removeParent(filename) {
    const message = 'Are you sure you want to delete ' + filename + ' ?';
    const dialogData = new ConfirmDialogModel(message, '');
    const dialogRef = this.dialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: dialogData });
    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        const FileValuesDelete = [];
        this.filename.forEach((file) => {
          if (file != filename) {
            FileValuesDelete.push(file);
          }
        });
        delete this.filename;
        this.filename = FileValuesDelete;

        const FileArrayValuesDelete = [];
        this.fileArray.forEach((file) => {
          if (file.name != filename) {
            FileArrayValuesDelete.push(file);
          }
        });
        delete this.fileArray;
        this.fileArray = FileArrayValuesDelete;
        // console.log( this.fileArray)
        this.fileSizeError = '';
      }
    });
  }
  ngOnDestroy() {
    // telemtry end call

    this.data1.subtype = 'Attachment-dialog cleanup stage/end of page';
    this.data1.itype = 'AUTO';
    this.data1.stageto = 'destroy component,initial page';
    if (this.data) {
      this._telemetryServices.telemetryEnd(this.data1);
    }
  }
}
